module.exports = __webpack_public_path__ + "static/media/wheel.61fc4873.svg";